<template>
  <vs-popup class="popup-select-977"
    title="공정분류표"
    :active.sync="showPopup">

    <vs-tabs v-model="currTab">
      <vs-tab label="공정별 환경시설 분류" />
      <vs-tab label="전체 환경시설 " />
    </vs-tabs>

    <page977 v-if="currTab === 0" ref="page977" mode="popup" @close="showPopup = false;" @select="onSelect"/>
    <page977 v-else mode="popup" all @close="showPopup = false;" @select="onSelect"/>
  </vs-popup>
</template>

<script>
import page977 from "@/views/boards/single-page/977/Page.vue";
export default {
  components: {
    page977
  },
  props: {
    value: Boolean,
  },
  watch: {

  },
  computed: {
    showPopup: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    }
  },
  data () {
    return {
      currTab: 0,
    }
  },
  methods: {
    onSelect (model) {
      this.$emit('select', model);
      this.showPopup = false;
    }
  }
}
</script>

<style scoped>

</style>

<style>
.popup-select-977 > .vs-popup {
  width: 1200px !important;
}
</style>
